"use client";
import AnalyticsTabs from "@/app/components/AnalyticsTabs";
import BtcPanel from "@/app/components/BtcPanel";
import EthPanel from "@/app/components/EthPanel";
import SolPanel from "@/app/components/SolPanel";
import { Box } from "@mui/material";
import { useSearchParams } from "next/navigation";

export default function AnalyticsPage() {
  const searchParams = useSearchParams();
  const tabParam = searchParams?.get("tab") || null;
  let tabIndex = 0;
  if (tabParam === "eth") tabIndex = 1;
  else if (tabParam === "sol") tabIndex = 2;

  return (
    <Box>
      <AnalyticsTabs />
      <Box>
        {tabIndex === 0 && <BtcPanel />}
        {tabIndex === 1 && <EthPanel />}
        {tabIndex === 2 && <SolPanel />}
      </Box>
    </Box>
  );
}
